import { FormGroup } from '@mui/material'
import FormControlLabel from '@mui/material/FormControlLabel'
import Typography from '@mui/material/Typography'

import CustomMuiCheckbox from '../../../Theme/Checkbox'

const ContestQualificationMapCheckList = ({ initialCheckList = [], checkList = [], checkListDisabled, onCheck }) => (
  <>
    <Typography
      sx={(theme) => ({
        ...theme.typography.h6,
        color: theme.palette.text.tertiary,
        margin: '32px 0 24px',
      })}
    >
      Technical Checklist
    </Typography>
    <FormGroup
      sx={(theme) => ({
        display: 'block',
        columnCount: 2,
        '& .MuiFormControlLabel-root': {
          color: theme.palette.text.secondary,
        },
        '& .MuiCheckbox-root': {
          alignSelf: 'flex-start',
        },
      })}
    >
      {initialCheckList.map((i) => (
        <FormControlLabel
          key={i.id}
          label={i.name}
          control={
            <CustomMuiCheckbox
              disabled={checkListDisabled}
              checked={checkList.includes(i.id)}
              onChange={(e) => onCheck(e, i.id)}
            />
          }
        />
      ))}
    </FormGroup>
  </>
)

export default ContestQualificationMapCheckList
